<div id="layout-wrapper">
  <app-top-bar></app-top-bar>
  <app-side-bar></app-side-bar>

  <div class="main-content">
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
